import React from 'react'
import '../assets/scss/main.scss'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import Main from '../components/Main'
import BrandColumn from '../components/BrandColumn'
import { connect } from 'react-redux';
import { compose } from 'redux'
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import { toggleDrawer as toggleDrawerAction } from '../state/app';
import { withRouter } from 'react-router';

class Template extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
    var aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.id = 'recaptcha';
    aScript.src = "https://www.google.com/recaptcha/api.js";
    document.head.appendChild(aScript);
  }

  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const { location, children } = this.props

    let content = '';
    if(isLoaded(this.props.state.home)) {
      content = (
        <div>
          <Helmet>
              <title>{siteTitle}</title>
              <meta name="description" content={siteDescription} />
          </Helmet>

          <div id="wrapper">
            <Main
              children={children}
              location={location}/>
            <BrandColumn
              location={location}/>
          </div>
        </div>
      );
    }

    return (
      <div className={`body`}>
        {content}
      </div>
    )
  }
}
export default compose(
  firebaseConnect([
    'home' // { path: '/todos' } // object notation
  ]),
  connect(
    ({app, firebase}) => ({
      state: {
        isDrawerOpen: app.isDrawerOpen,
        home: firebase.data.home
      }
    }),
    dispatch => ({ toggleDrawer: open => dispatch(toggleDrawerAction(open)) }),
  )
)(withRouter(Template))

export const pageQuery = graphql`
query PageQuery {
  site {
    siteMetadata {
      title
      description
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/layouts/index.js